import React from 'react'
import { useMediaQuery } from 'react-responsive'
import Carousel, { ResponsiveType } from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import {
  DESKTOP_WIDTH,
  PHONE_WIDTH,
  TABLET_WIDTH,
} from '../../constants/measurements'

import * as S from '../../styles/workouts.styles'
import * as I from '../shared/Icons'
import WorkoutItem from './Components/WorkoutItem'
import { WHITE } from '../../constants/colors'
import { GenericWorkout } from '../../types/generic-workout'

const responsive: ResponsiveType = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    paritialVisibilityGutter: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: DESKTOP_WIDTH },
    items: 4,
    slidesToSlide: 4,
  },
  tablet: {
    breakpoint: { max: DESKTOP_WIDTH, min: PHONE_WIDTH },
    items: 3,
    slidesToSlide: 3,
  },
  mobile: {
    breakpoint: { max: PHONE_WIDTH, min: 0 },
    items: 2,
    slidesToSlide: 5,
  },
}

interface Props {
  workouts: GenericWorkout[]
  isLargerRow?: boolean
  isEditable?: boolean
}

const WorkoutsRow: React.FC<Props> = (props: Props) => {
  const { workouts, isLargerRow, isEditable } = props
  const isTabletOrMobile = useMediaQuery({
    query: `(max-width: ${TABLET_WIDTH}px)`,
  })

  const renderItem = (w: GenericWorkout) => {
    if (w.published) {
      return <WorkoutItem key={w.id} workout={w} isEditable={isEditable} />
    } else {
      if (isEditable) {
        return <WorkoutItem key={w.id} workout={w} isEditable={isEditable} />
      }
      return null
    }
  }

  const CustomLeftArrow = ({ onClick }: any) => (
    <S.CustomArrowWrap
      isLargerRow={isLargerRow}
      style={{
        top: 0,
        left: 10,
      }}
      onClick={() => onClick()}
    >
      <S.ChevronContainer>
        <I.ChevronLeft56 color={WHITE} />
      </S.ChevronContainer>
    </S.CustomArrowWrap>
  )

  const CustomRightArrow = ({ onClick }: any) => (
    <S.CustomArrowWrap
      isLargerRow={isLargerRow}
      style={{
        top: 0,
        right: 10,
      }}
      onClick={() => onClick()}
    >
      <S.ChevronContainer>
        <I.ChevronRight color={WHITE} />
      </S.ChevronContainer>
    </S.CustomArrowWrap>
  )

  return (
    <Carousel
      responsive={responsive}
      draggable={true}
      swipeable={true}
      arrows={!isTabletOrMobile}
      customLeftArrow={<CustomLeftArrow />}
      customRightArrow={<CustomRightArrow />}
    >
      {workouts.map(w => renderItem(w))}
    </Carousel>
  )
}

export default WorkoutsRow
